class NeocomProductConsulting extends HTMLElement {
    constructor() {
        super();
        console.log("this.setupProductConsulting");
        this.setupProductConsulting();
    }

    setupProductConsulting() {
        const wrapperElem = this.querySelector(".neocom-blogpost--wrapper");
        var target = document.querySelector(".product-consulting");
        if (!target) {
            target = Array.from(document.querySelectorAll('.sse-row + .sse-row[draggable="false"]')).find((item) =>
                item.childNodes && item.childNodes[1]?.classList?.contains("sse-half")
            );
            if (!target) {
                target = document.querySelector('.sse-row + .sse-row[draggable="false"]');
                if (!target) {
                    const totalSize = document.querySelectorAll('.sse-row').length;

                    target = document.querySelectorAll('.sse-row')[(totalSize / 2).toFixed()];
                }
            }
        }
        if (wrapperElem && target) {
            const wrapperCopyElem = wrapperElem.cloneNode(true);
            target.parentNode.insertBefore(wrapperCopyElem, target);
        }
    }
}

customElements.define('neocom-product-consulting', NeocomProductConsulting);
